import { NAV_SECTIONS } from "@/util/navigation";
import Link from "next/link";
import React from "react";

type NavLinksProps = {
  className?: string;
  activeId?: string;
  isHomeRoute: boolean;
  onNavigate: (id: string) => void;
};

export function NavLinks({
  className,
  activeId,
  isHomeRoute,
  onNavigate,
}: NavLinksProps) {
  return (
    <>
      {NAV_SECTIONS.map((session) => {
        const isActive = isHomeRoute && activeId === session.id;
        const base =
          "inline-flex w-fit items-center justify-center rounded-lg border border-transparent px-3 py-1.5 text-base font-medium no-underline transition-colors focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/70 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent";
        const activeCls = "bg-accent text-accent-foreground";
        const inactiveCls =
          "text-muted-foreground hover:text-foreground hover:bg-muted/50";
        const href =
          session.id === "about"
            ? "/"
            : isHomeRoute
              ? `#${session.id}`
              : `/#${session.id}`;
        return (
          <Link
            key={session.id}
            className={`${base} ${isActive ? activeCls : inactiveCls} ${className || ""}`}
            href={href}
            // Not prefetched: these links sit in the header of every page and
            // all resolve to the home route, so prefetching pulls the whole
            // home bundle into every page load. Navigation happens through
            // onNavigate below anyway.
            prefetch={false}
            aria-current={isActive ? "page" : undefined}
            onClick={(event) => {
              event.preventDefault();
              onNavigate(session.id);
            }}
          >
            {session.label}
          </Link>
        );
      })}
    </>
  );
}
